import $ from "jquery";

// Ajout de JS pour le style du formulaire
$(document).ready(function(){
    if($('input:radio').is(':checked')) {
        //console.log('toto');
    }

    // $('input:radio').click(function() {
    //     if($(this).is(':checked')) { 
    //         $(this).parent().toggleClass('active');
    //     }
    // });
})